const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdentityCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE049"
    },
    d: "M441.32,371.989H30.846c-11.403,0-20.647-9.244-20.647-20.647V120.825 c0-11.403,9.244-20.647,20.647-20.647H441.32c11.403,0,20.647,9.244,20.647,20.647v230.516 C461.967,362.744,452.722,371.989,441.32,371.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9CDCFF"
    },
    d: "M481.154,411.823H70.68c-11.403,0-20.647-9.244-20.647-20.647V160.659 c0-11.403,9.244-20.647,20.647-20.647h410.474c11.403,0,20.647,9.244,20.647,20.647v230.516 C501.801,402.578,492.557,411.823,481.154,411.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#45B5F5"
    },
    d: "M116.115,362.409c0-37.489,32.455-67.88,72.49-67.88s72.49,30.391,72.49,67.88L116.115,362.409 L116.115,362.409z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE049"
    },
    cx: 187.818,
    cy: 227.31,
    r: 39.366
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B404F"
    },
    d: "M481.155,129.813h-8.989v-8.989c0-17.009-13.837-30.846-30.845-30.846H30.846 C13.837,89.979,0,103.816,0,120.825v230.517c0,17.008,13.837,30.845,30.846,30.845h8.989v8.989 c0,17.009,13.837,30.846,30.846,30.846h410.474c17.008,0,30.845-13.837,30.845-30.846V160.659 C512,143.651,498.163,129.813,481.155,129.813z M30.846,361.79c-5.761,0-10.448-4.687-10.448-10.447V120.825 c0-5.761,4.687-10.448,10.448-10.448H441.32c5.761,0,10.447,4.688,10.447,10.448v8.989H70.68 c-17.008,0-30.846,13.837-30.846,30.845v201.13H30.846z M491.602,391.176c0,5.761-4.687,10.448-10.447,10.448H70.68 c-5.761,0-10.448-4.688-10.448-10.448V160.659c0-5.76,4.687-10.447,10.448-10.447h410.474c5.761,0,10.447,4.687,10.447,10.447 L491.602,391.176L491.602,391.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B404F"
    },
    d: "M326.464,227.875h123.164c5.632,0,10.199-4.567,10.199-10.199s-4.567-10.199-10.199-10.199H326.464 c-5.632,0-10.199,4.567-10.199,10.199S320.831,227.875,326.464,227.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B404F"
    },
    d: "M326.464,288.058h123.164c5.632,0,10.199-4.567,10.199-10.199c0-5.632-4.567-10.199-10.199-10.199 H326.464c-5.632,0-10.199,4.567-10.199,10.199C316.265,283.49,320.831,288.058,326.464,288.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B404F"
    },
    d: "M450.134,327.841h-7.381c-5.632,0-10.199,4.567-10.199,10.199c0,5.632,4.567,10.199,10.199,10.199 h7.381c5.632,0,10.199-4.567,10.199-10.199C460.333,332.408,455.766,327.841,450.134,327.841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B404F"
    },
    d: "M407.136,327.841h-80.672c-5.632,0-10.199,4.567-10.199,10.199c0,5.632,4.567,10.199,10.199,10.199 h80.672c5.632,0,10.199-4.567,10.199-10.199C417.335,332.408,412.768,327.841,407.136,327.841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B404F"
    },
    d: "M188.605,284.33c-45.596,0-82.689,35.026-82.689,78.079c0,5.632,4.566,10.199,10.199,10.199h144.981 c5.632,0,10.199-4.567,10.199-10.199C271.295,319.356,234.2,284.33,188.605,284.33z M177.706,305.619v46.592h-50.417 C131.871,328.528,152.115,309.818,177.706,305.619z M198.104,352.21v-46.798c26.249,3.736,47.153,22.687,51.817,46.798H198.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B404F"
    },
    d: "M187.813,276.875c27.33,0,49.565-22.235,49.565-49.565s-22.234-49.565-49.565-49.565 s-49.565,22.235-49.565,49.565S160.483,276.875,187.813,276.875z M187.813,198.144c16.082,0,29.167,13.084,29.167,29.167 s-13.085,29.167-29.167,29.167s-29.167-13.084-29.167-29.167S171.731,198.144,187.813,198.144z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityCard);
export default __webpack_public_path__ + "static/media/identity-card.73161d2788fa135374e7d321c5632399.svg";
export { ForwardRef as ReactComponent };